import { render, staticRenderFns } from "./ApeTable.vue?vue&type=template&id=1482e0d0&scoped=true&"
import script from "./ApeTable.vue?vue&type=script&lang=js&"
export * from "./ApeTable.vue?vue&type=script&lang=js&"
import style0 from "./ApeTable.vue?vue&type=style&index=0&id=1482e0d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482e0d0",
  null
  
)

export default component.exports